import React from 'react';
import { Link } from 'react-scroll';
import { FormattedMessage } from 'react-intl';

import { Container, BottomArrow, Copy } from './jumpToSection.styles';

export interface JumpToSectionProps {
  elementName: string;
}

export const JumpToSection = ({ elementName }: JumpToSectionProps) => (
  <Container style={{ marginBottom: 7 }} data-testid="continue-reading-button">
    <Link style={{ borderBottom: 'none' }} to={elementName} smooth duration={500} href={`#${elementName}`}>
      <BottomArrow />
      <Copy>
        <FormattedMessage id="JumpToSection.copy" defaultMessage={elementName} />
      </Copy>
    </Link>
  </Container>
);
